export enum SelectableOptions {
  Option1 = "Option 1",
  Option2 = "Option 2",
  Option3 = "Option 3",
}
